const mentor  = {
    observasi: {
        icon: 'file-done',
        text: 'Observasi',
        route: 'admin.performance.mentoring.observation',
        role: {
            performance: [ 'mentor' ],
        },
    },
    monitoring: {
        icon: 'video-camera',
        text: 'Monitoring',
        route: 'monitoring',
        role: {
            performance: [ 'mentor', 'attendant' ],
        },
        children: {
            coaching: {
                icon: null,
                text: 'Coaching',
                route: 'admin.performance.coaching',
                role: {
                    performance: [ 'mentor', 'attendant' ],
                },
            },
            mentoring: {
                icon: null,
                text: 'Mentoring',
                route: 'admin.performance.mentoring',
                role: {
                    performance: [ 'mentor', 'attendant' ],
                },
            },
            counseling: {
                icon: null,
                text: 'Counseling',
                route: 'admin.performance.counceling',
                role: {
                    performance: [ 'mentor', 'attendant' ],
                },
            },
        }
    },
    performanceRecap: {
        icon: 'control',
        text: 'Performance Mentor',
        route: 'admin.performance.mentoring.recap',
        role: {
            performance: [ 'mentor' ],
        },
    }
}

export default mentor
